import script from "./FooterRfl.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterRfl.vue?vue&type=script&setup=true&lang=js"

import "./FooterRfl.vue?vue&type=style&index=0&id=ccf51ac6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ccf51ac6"]])

export default __exports__